import { useRef } from "react";

// Pointer driven 3D tilt with a moving specular glare. Used on product and bundle cards.
export const TiltMedia = ({ children, className = "" }) => {
  const inner = useRef(null);
  const glare = useRef(null);

  const onMove = (e) => {
    const el = inner.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    const rx = (0.5 - py) * 10;
    const ry = (px - 0.5) * 12;
    el.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) scale(1.04)`;
    if (glare.current) {
      glare.current.style.opacity = "1";
      glare.current.style.background = `radial-gradient(240px circle at ${px * 100}% ${py * 100}%, rgba(160,178,255,0.28), transparent 60%)`;
    }
  };

  const onLeave = () => {
    const el = inner.current;
    if (!el) return;
    el.style.transform = "rotateX(0deg) rotateY(0deg) scale(1)";
    if (glare.current) glare.current.style.opacity = "0";
  };

  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={{ perspective: "800px" }}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
    >
      <div
        ref={inner}
        className="relative w-full h-full"
        style={{ transformStyle: "preserve-3d", transition: "transform 0.3s cubic-bezier(0.2,0.8,0.2,1)" }}
      >
        {children}
        <div
          ref={glare}
          className="pointer-events-none absolute inset-0"
          style={{ opacity: 0, transition: "opacity 0.3s ease", mixBlendMode: "screen" }}
        />
      </div>
    </div>
  );
};
